import React, { useState } from 'react';
import classnames from 'classnames';
import Button, { themes } from '../UI/Button/Button';
import Columns from '../UI/Columns/Columns';
import Link from '../UI/Link/Link';
import useChunked from '../../hooks/useChunked';
import * as styles from './QuestionList.module.scss';

const QuestionList = ({ nodes, isChunked = false, chunkSize = 10, ...other }) => {
  const [ pageIndex, setPage ] = useState(0);
  const { currentNodes, hasMore } = useChunked(nodes, { pageIndex, chunkSize, isChunked });

  function handleLoadMoreClick() {
    if (hasMore) {
      setPage(pageIndex + 1);
    }
  }

  return !nodes ? null : (
    <>
      <Columns
        className={classnames(styles.list, {
          [ styles.isChunked ]: isChunked
        })}
        count={2}
        containerTag="ul"
        itemTag="li"
        showBorders={false}
        {...other}
      >
        {currentNodes.map(({ id, title, uri }) => (
          <Link className={styles.link} to={uri} key={id}>
            {title}
          </Link>
        ))}
      </Columns>

      {isChunked && hasMore && (
        <Button hideIcon onClick={handleLoadMoreClick} theme={themes.LINK}>
          View more
        </Button>
      )}
    </>
  );
};

export default QuestionList;
